import axios, { AxiosError } from "axios";

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    function (error: AxiosError) {
        if (window.location.toString().indexOf("public") == -1) {
            if (error.isAxiosError && error.response == null) {
                return error;
            }
            if (error.code == "401") {
                window.location.pathname = "/Account/SignIn";
            }
        }
        return error.response;
    }
);

export let TrimFields = (obj) => {
    Object.keys(obj).map((k) => (obj[k] = obj[k].trim()));
    return obj;
};

export default axios;

export interface APIWrapperResponse<T> {
    message: string;
    result: T;
}

export interface DefaultResponse {
    success: boolean;
    errors: string[];
    code: string;
}

export interface TypedResponse<T> extends DefaultResponse {
    result: T;
}
